import React from "react";

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  /** Appends the required marker the forms render by hand today. */
  required?: boolean;
  /** "muted" is the lighter gray-500 variant used on detail views. */
  tone?: "default" | "muted";
}

const TONE = {
  default: "text-gray-700 dark:text-gray-300",
  muted: "text-gray-500 dark:text-gray-400",
};

// This class string appeared 59 times across the modals, with a second
// gray-500 variant another 27.
const Label: React.FC<LabelProps> = ({
  required = false,
  tone = "default",
  className = "",
  children,
  ...rest
}) => (
  <label
    className={`mb-2 block text-sm font-medium ${TONE[tone]} ${className}`}
    {...rest}
  >
    {children}
    {required && <span className="ml-0.5 text-red-500">*</span>}
  </label>
);

export default Label;
